import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import { Button } from "@mui/material";
import { formatDate } from "../../../libs/utils";
import { useTimezone } from "../../../contexts/TimezoneContext";

const TxnPartnerSwitchTrail = ({
  transaction_info_list = [],
  handleWebhookDetail,
}) => {
  const { timezoneValue } = useTimezone();

  if (!transaction_info_list.length) {
    return <></>;
  }

  return (
    <>
      <div className="lineBreak" />
      <div className="row">
        <div className="col-md-12">
          <div className="mb-3">
            <label className="form-label fw-bold text-secondary user-select-none">
              Partner Switch Trail
            </label>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="partner switch trail">
                <TableHead>
                  <TableRow>
                    <TableCell>Partner</TableCell>
                    <TableCell>Initiated Date and Time</TableCell>
                    <TableCell>status</TableCell>
                    <TableCell>Inititation Flow</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transaction_info_list.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.partner}</TableCell>
                      <TableCell>
                        {formatDate(
                          row.transaction_completion_time,
                          timezoneValue
                        )}
                      </TableCell>
                      <TableCell>{row.status}</TableCell>
                      <TableCell>{row.transaction_initiation_flow}</TableCell>
                      <TableCell>
                        {row.transaction_id && (
                          <Button
                            variant="contained"
                            size="medium"
                            color="primary"
                            onClick={handleWebhookDetail.bind(
                              null,
                              row.transaction_id
                            )}
                          >
                            Check
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </>
  );
};

export default TxnPartnerSwitchTrail;
